import React, {Component} from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import {EnvelopeSummarySigners} from '../EnvelopeSummary/envelopeSummarySigners';
import {EnvelopeSummaryDocuments} from '../EnvelopeSummary/envelopeSummaryDocuments';
import Divider from '@material-ui/core/Divider';
import {Row, Col} from '@deere/ux.uxframe-react';
import {EmptyStateLayout} from '../EmptyPage';
import {getKey} from '../../GenerateKey';
import {DocumentIcon, PersonIcon} from '../../Icon';
import {DeereFetch} from '../../../shared/fetch';
import {docusignErrorCodes, envelopeReviewBlankPageMessage} from '../Constants/constants';
import JDFSigner from '../Constants/JDFSigner.json'
import JDFReviewer from '../Constants/JDFReviewer.json';
import style from './index.css';
import {ReviewMessages} from './ReviewMessages';
import {ErrorMessage} from '../Error';
import {FormattedMessage} from 'react-intl';
import {documentsToBeReviewed} from '../../../mappers/CountryDocumentMappers';
import PropTypes from 'prop-types';
import EnvelopeCreationSuccessPopup from './EnvelopeCreationSuccessPopup';
import EnvelopeSentMessagePopup from './EnvelopeSentMessagePopup';

export class Review extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            envelopeCreated: false,
            envpError: false,
            apiErrorMessage: '',
            apiErrorCode: ''
        };

        this.handleSendEnvelope = this.handleSendEnvelope.bind(this);
    }

    async handleSendEnvelope() {
        const {
            bundleNumber,
            createdBy,
            countryCode,
            documentDetails,
            financeProduct,
            primaryCustomerName,
            quoteNumber,
            signersDetails

        } = this.props;
        this.props.disableCreateEnvelopeTabs(true);
        this.setState({downloading: true});
        this.setState({envpError: false});
        const body = {
            country: countryCode,
            bundleNumber: bundleNumber,
            quoteNumber: quoteNumber,
            createdBy: createdBy,
            financeProduct: financeProduct,
            primaryCustomerName: primaryCustomerName,
            letters: documentDetails.map((document) => {
                return {
                    code: document['code'],
                    description: document['description']
                };
            }),
            associatedParties: signersDetails.map((signer) => {
                return {
                    role: signer.role,
                    emailID: signer.emailID.trim(),
                    name: signer.name,
                    recipientId: signer.recipientId,
                    routingOrder: signer.signingOrder,
                    signingOption: signer.signingMethod,
                    representativeFor: signer.representativeFor,
                    tpNumber: signer.tpNumber,
                    thirdPartyClass : signer.thirdPartyClass,
                    countryCodeforPhone: signer.phoneNumber.replace(/\D/g, '').slice(0, 2),
                    contactNumber: signer.phoneNumber.replace(/\D/g, '').slice(2)
                };
            })
        };

        const documentsForJDFAssociatedParties = documentDetails.filter(document => documentsToBeReviewed(countryCode, financeProduct).includes(document.code))
        if (documentsForJDFAssociatedParties.length > 0) {
            if(countryCode === 'ES' || countryCode === 'PT') {
                body.associatedParties.push(JDFReviewer)
                body.associatedParties.push(JDFSigner)
            }
        }

        try {
            await DeereFetch('/api/esign/create-envelope', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(body)
            });
            this.setState({downloading: false});
            this.setState({envelopeCreated: true});
            this.props.disableCreateEnvelopeTabs(false);
            this.setState({quoteNumber:quoteNumber})
        } catch (err) {
            this.setState({downloading: false});
            this.props.disableCreateEnvelopeTabs(false);
            this.setState({envpError: true}, () => {
                return true
            });
            this.setState({apiErrorMessage: err.Message});
            if (Object.prototype.hasOwnProperty.call(err, 'ErrorCode')) {
                this.setState({apiErrorCode: err.ErrorCode});
            }
        }
    }

    render() {
        let errorMessage = this.state.apiErrorMessage;
        if (docusignErrorCodes.includes(this.state.apiErrorCode)) {
            errorMessage = <FormattedMessage id={'docusignErrorMessages.' + this.state.apiErrorCode}/>;
        }
        return (
            <div style={{minHeight: '300px'}}>
                {
                    this.props.signersDetails.length === 0 && this.props.documentDetails.length === 0 ?
                        <EmptyStateLayout
                            context={envelopeReviewBlankPageMessage['NO_SIGNER_DOCUMENT_SELECTED_MESSAGE']}
                            message={envelopeReviewBlankPageMessage['NO_SIGNER_DOCUMENT_SELECTED_ACTION']}
                        /> :
                        <div>
                            {
                                this.state.envpError &&
                                <span className={`d-flex ml-auto mb-2 ${style.errorMessage}`}>
                                    <ErrorMessage cssFlag={false} message={errorMessage} showIcon={true}/>
                                </span>
                            }
                            <Row className={style.reviewInfo}>
                                <div>
                                    <span> <FormattedMessage id={'labels.PROPOSAL'}/>: {this.props.quoteNumber}
                                        | <FormattedMessage
                                            id={'labels.SIGNERS'}/>:{' '}{this.props.signersDetails.length}
                                        | <FormattedMessage
                                            id={'labels.DOCUMENTS'}/>:{' '}{this.props.documentDetails.length}
                                    </span>
                                    {
                                        ReviewMessages.map(info =>
                                            <span className="d-block mb-1 pl-3" key={'info-' + getKey()}>
                                                {info}
                                            </span>
                                        )
                                    }
                                </div>
                                <div>
                                    <Box display="flex" justifyContent="flex-end">
                                        {this.state.downloading ? (
                                            <EnvelopeSentMessagePopup/>
                                        ) : (
                                            this.state.envelopeCreated ? (
                                                <EnvelopeCreationSuccessPopup
                                                    quoteNumber={this.state.quoteNumber}/>
                                            )
                                                : (
                                                    <div>
                                                        <Button
                                                            color="primary"
                                                            disabled={
                                                                !(this.props.signersDetails.length > 0 &&
                                                                    this.props.documentDetails.length > 0 &&
                                                                    this.props.showError)
                                                            }
                                                            onClick={this.handleSendEnvelope}
                                                            size="medium"
                                                            variant="contained"
                                                        >
                                                            <FormattedMessage id={'labels.SEND_ENVELOPE'}/>
                                                        </Button>
                                                    </div>
                                                )
                                        )}
                                    </Box>
                                </div>
                            </Row>
                            <Row>
                                <Col>
                                    {this.props.signersDetails.length === 0 && (
                                        <div
                                            className="d-flex flex-column align-items-center"
                                            style={{marginTop: 45}}>
                                            <PersonIcon className="text-black-50 uxf-icon-lg"/>
                                            <h6 className="text-black-50">
                                                {envelopeReviewBlankPageMessage['NO_SIGNER_SELECTED']}
                                            </h6>
                                        </div>
                                    )}

                                    {this.props.signersDetails
                                        .sort((signer1, signer2) =>
                                            (signer1.signingOrder > signer2.signingOrder ? 1 : -1)
                                        )
                                        .map((signer, i) => (
                                            <EnvelopeSummarySigners
                                                contact={signer.phoneNumber}
                                                email={signer.emailID}
                                                isDuplicate={Array.from(
                                                    this.props.duplicateSignerSet
                                                ).includes(signer.tpNumber)}
                                                key={'Signer-' + i + getKey()}
                                                name={signer.name}
                                                role={signer.role}
                                                signingMethod={signer.signingMethod}
                                                signingOrder={signer.signingOrder}
                                            />
                                        ))}
                                </Col>
                                <Divider flexItem orientation="vertical"/>
                                <Col>
                                    {this.props.documentDetails.length === 0 && (
                                        <div
                                            className="d-flex flex-column align-items-center"
                                            style={{marginTop: 45}}
                                        >
                                            <DocumentIcon className="text-black-50 uxf-icon-lg"/>
                                            <h6 className="text-black-50">
                                                {envelopeReviewBlankPageMessage['NO_DOCUMENT_SELECTED']}
                                            </h6>
                                        </div>
                                    )}
                                    {this.props.documentDetails.map((documentName, i) => (
                                        <EnvelopeSummaryDocuments
                                            documentName={documentName.description}
                                            key={'DocSummary-' + i + getKey()}
                                        />
                                    ))}
                                </Col>
                            </Row>
                        </div>
                }
            </div>
        );
    }
}

Review.propTypes = {
    createdBy: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    disableCreateEnvelopeTabs: PropTypes.func.isRequired,
    documentDetails: PropTypes.array.isRequired,
    duplicateSignerSet: PropTypes.array.isRequired,
    duplicateEmailMobileNoSet: PropTypes.array.isRequired,
    financeProduct: PropTypes.string.isRequired,
    primaryCustomerName: PropTypes.string.isRequired,
    quoteNumber: PropTypes.string.isRequired,
    showError: PropTypes.bool.isRequired,
    signersDetails: PropTypes.array.isRequired
};
